// extracted by mini-css-extract-plugin
export default {"orderDashboardLabel":"u4CfomhXS2Qdh8I4x0o0","backToDashboardContainer":"gEmU5h5AYxs5KgzSEkyS"};